// extracted by mini-css-extract-plugin
export default {"calendar":"commessa-note_calendar__FP5fw","table":"commessa-note_table__ZypRc","print":"commessa-note_print__pPbqY"};